<template>
    <base-nav class="navbar-main navbar-vertical fixed-left bg-white" type="" effect="light" expand>
        <router-link :to="{name: 'home'}" class="navbar-brand mr-lg-5" slot="brand">
            <img v-lazy="'img/brand/sic.png'" class="">
        </router-link>

        <div class="row" slot="content-header" slot-scope="{closeMenu}">
            <div class="col-6 collapse-brand">
                <router-link :to="{name: 'home'}" class="" slot-scope="{closeMenu}">
                    <img v-lazy="'img/brand/sic.png'" class="">
                </router-link>
            </div>
            <div class="col-6 collapse-close">
                <close-button @click="closeMenu"></close-button>
            </div>
        </div>


        <!-- Navigation -->
        <ul class="navbar-nav">
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'home'}">
                    <i class="ni ni-tv-2 text-primary"></i> Dashboard
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website'}">
                    <i class="ni ni-world text-blue"></i> Website
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-users'}">
                    <i class="ni ni-single-02 text-yellow"></i> Users
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-users-deleted'}">
                    <i class="fas fa-trash text-danger"></i> Deleted Users
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-ideas'}">
                    <i class="ni ni-bulb-61 text-success"></i> Ideas
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-news'}">
                    <i class="far fa-newspaper"></i> News
                </router-link>
            </li>

            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-events'}">
                    <i class="far fa-calendar-alt"></i> Events
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-contacts'}">
                    <i class="fas fa-envelope-open text-primary"></i> Contact Messages
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-project'}">
                    <i class="fas fa-project-diagram text-danger"></i> Project
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-testimonials'}">
                    <i class="fas fa-project-diagram text-danger"></i> Testimonials
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-stories'}">
                    <i class="ni ni-books text-primary"></i> Success Stories
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-memberships'}">
                    <i class="ni ni-single-02 text-primary"></i> Memberships
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-departments'}">
                    <i class="ni ni-single-02 text-primary"></i> Sustateam Departments
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-susteams'}">
                    <i class="ni ni-single-02 text-primary"></i> Sustateam
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-management-departments'}">
                    <i class="ni ni-single-02 text-primary"></i> Management Departments
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-managements-teams'}">
                    <i class="ni ni-single-02 text-primary"></i> Management Members
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'website-newsletter-subscribers'}">
                    <i class="ni ni-single-02 text-primary"></i> Newsletter Subscribers
                </router-link>
            </li>
        </ul>
        <!-- Divider -->
        <hr class="my-3">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" href="">
                    <i class="ni ni-building text-info"></i> Buildings
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="">
                    <i class="fas fa-table text-danger"></i> Floors
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="">
                    <i class="fas fa-door-open text-teal"></i> Rooms
                </a>
            </li>
        </ul>
        <hr class="my-3">
        <ul class="navbar-nav">
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'user-profile'}">
                    <i class="ni ni-single-02 text-info"></i> Profile
                </router-link>
            </li>
        </ul>
        <hr class="d-md-none my-3">
        <ul class="navbar-nav d-md-none">
            <li class="nav-item">
                <a @click.prevent="logoutUser" class="nav-link" href="/logout">
                    <i class="ni ni-button-power text-danger"></i> Logout
                </a>
            </li>
        </ul>
    </base-nav>
</template>

<script>
import axios from "axios";
import router from "../router";
import BaseNav from "../components/BaseNav";
import BaseDropdown from "../components/BaseDropdown";
import CloseButton from "../components/CloseButton";

export default {
  name: "Sidebar",
  methods: {
    logoutUser() {
      axios({
        method: "post",
        url: "admin/logout",
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("expiration_date");
            router.push({ path: "/" });
            console.log(result);
            window.location.reload(true);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>

<style scoped>
</style>
